module.exports = __webpack_public_path__ + "static/media/starterguidestep5.393bed36.png";